/** @format */

import {Box} from '@mui/material';

import CustomInfo from './CustomInfo';
import IdText from './IdText';

const Sitelink = props => {
  const sample = props.reportItemGroup[0];
  const showCustomInfo = sample.maxLocationField === 'sitelinkId';

  return (
    <Box display='flex' flexDirection='column'>
      <IdText id={sample.sitelinkId} text={sample.sitelink} />

      {showCustomInfo && (
        <CustomInfo reportItemGroup={props.reportItemGroup} sensorName={props.sensorName} />
      )}
    </Box>
  );
};

export default Sitelink;
